import { render, staticRenderFns } from "./RuralHobbyFarm.vue?vue&type=template&id=b0a321f2&scoped=true&"
import script from "./RuralHobbyFarm.vue?vue&type=script&lang=ts&"
export * from "./RuralHobbyFarm.vue?vue&type=script&lang=ts&"
import style0 from "./RuralHobbyFarm.vue?vue&type=style&index=0&id=b0a321f2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0a321f2",
  null
  
)

export default component.exports